import { SeatIcon } from './SeatIcon';

/**
 * author: Google
 * id C9A796D6-1A7D-47AD-A036-B3B9035FBDA3
 * name seat
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/seat.svg
 * tags
 * - Home Automation 
 */
export const ChairIcon = SeatIcon;
export default ChairIcon